import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

ChartJS.register(
  ArcElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
);

if (!Tooltip.positioners.cursor) {
  Tooltip.positioners.cursor = (_, eventPosition) => ({
    x: eventPosition.x,
    y: eventPosition.y,
  });
}
